<template lang="pug">
	.mraid-sdk
		hr
		.status-container
			.status.not-passed(v-if="status === 'not-passed'") NOT PASSED
			.status.partially-passed(v-if="status === 'partially-passed'") PASSED
			.status.fully-passed(v-if="status === 'fully-passed'") FULLY PASSED
			.status.error(v-if="status === 'error'") ERROR
		.errors
			.error(v-for="step in Testing.mraidSDKStepsDefinition" v-if="step.error")
				.title(v-html="'Error: ' + step.error")
		.steps
			.step(v-for="stepDefinition in Testing.mraidSDKStepsDefinition" :class="{primary: stepDefinition.primary, passed: stepDefinition.passed, error: !!stepDefinition.error}")
				.status.fa(:class="{'fa-circle-thin': !stepDefinition.error && !stepDefinition.passed, 'fa-circle': stepDefinition.error || stepDefinition.passed}")
				.title(v-html="stepDefinition.title")
			.step.additional(v-for="step in Testing.mraidSDKSteps" :class="{primary: false, passed: !!step.passed, error: !!step.error}")
				.status.fa(:class="{'fa-circle-thin': !step.error && !step.passed, 'fa-circle': step.error || step.passed}")
				.title(v-html="step.title")

</template>

<script>

	import Screen 							from './../../../mixins/screen'

	export default {
		name: 'MraidSDK',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Changed",
				"Settings Tab Changed:mraid-sdk",
				"Testing Step Added",
				"Testing Steps Cleared"
			],
			events: {

			}
		},
		components: {

		},
		data() {

			return {
				showed: true,
				status: null
			};

		},
		mounted() {

		},
		methods: {

			collectData() {

				this.status = Testing.getMraidSDKStatus();

			}

		}

	}
</script>

<style lang="sass">

	.mraid-sdk
		user-select: none

		hr
			margin-bottom: 1rem !important

		.status-container
			display: flex
			justify-content: center
			padding: 10px

			.status
				padding: 0.375rem 0.75rem
				font-size: 0.875rem
				line-height: 1.5
				border-radius: 0.25rem
				white-space: nowrap

			.status.not-passed
				border: 1px solid var(--danger)
				background-color: #2f353a
				color: var(--secondary)

			.status.partially-passed
				border: 1px solid var(--green)
				background-color: #2f353a
				color: var(--green)

			.status.fully-passed
				border: 1px solid var(--green)
				background-color: var(--teal)
				color: var(--white)

			.status.error
				border: 1px solid var(--red)
				background-color: var(--danger)
				color: var(--white)

		.steps
			display: flex
			flex-direction: column
			border: 1px solid #23282c
			border-radius: 5px
			background-color: #343b41
			font-size: 12px
			overflow: hidden

			.step
				display: flex
				flex-direction: row
				align-items: center
				padding: 0 5px 0px 5px
				min-height: 30px
				border-bottom: 1px solid rgba(0,0,0,0.1)
				user-select: text
				transition: background-color 0.2s

				.status
					display: flex
					align-items: center
					justify-content: center
					width: 20px
					margin-right: 4px
					color: var(--gray)

				.title
					color: var(--secondary)

					b
						color: var(--orange)
						font-weight: normal

				.title.error
					color: var(--red)

			.step.primary

				.status
					color: var(--red)

			.step.passed

				.status
					color: var(--green)

				.title
					color: var(--green)

			.step.error

				.status
					color: var(--red)

				.title
					color: var(--red)

			.step.additional
				background-color: rgba(255,255,255,0.02)

			.step:hover
				background-color: rgba(0,0,0,0.1)

			.step:last-child
				border-bottom: 0

			.step.additional

				.status
					color: var(--primary)

				.title
					color: var(--secondary)

		.errors
			margin-bottom: 10px

			.error
				color: var(--red)

				.title
					color: var(--danger)

					b
						color: var(--orange)
						font-weight: normal

</style>
